import { createFileRoute } from '@tanstack/react-router';
import LibraryGridComponent from 'src/Administration/PageContent/PageContentLibrary/LibraryGrid/LibraryGrid';

export const Route = createFileRoute('/systemadmin/_layout/page-content/library/grid')({
  component: LibraryGridComponent,
});
